<template>
  <div>
    <template v-if="action.processing">
      <loader :content="'Please wait'" :visible="action.processing" />
    </template>
    <template v-else>
      <div class="container" style="padding-top: 25px">
        <div class="row text-center">
          <div class="col-md-8 col-md-offset-2 text-center">
            <template v-if="action.succeed">
              <h3 class="--green"><b>Success !</b></h3>
              <p class="text-center mb-20">
                You may close this window at any time.
              </p>
            </template>
            <template v-else>
              <h3 class="sts-danger"><b>Oops!</b></h3>
              <p class="text-center mb-20">
                {{ action.message }}
              </p>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      reservationId: null,
      amendmentId: null,
      state: null,
      mail: null,
      action: {
        processing: true,
        succeed: false,
        message: "Something went wrong, please try again later.",
      },
    };
  },
  created() {
    this.constructParams();
  },
  async mounted() {
    FreshworksWidget("hide");
    const self = this;
    const url = `${process.env.VUE_APP_BASE_API}/api/shop/reservations/${this.reservationId}/amend/${this.amendmentId}/respond`;
    const config = {
      headers: { _pub: "true" },
    };

    await axios
      .get(url + `?state=${this.state}&mail=${this.mail}`, config)
      .then((response) => {
        if (response.data.isSuccess) {
          self.action.processing = false;
          self.action.succeed = true;
        } else {
          self.action.processing = false;
          self.action.succeed = false;
          self.action.message = response.data.errors[0];
        }
      })
      .catch((error) => {
        self.handleError(error);
      });
  },
  methods: {
    constructParams() {
      if (this.$route.query.state && this.$route.query.mail) {
        this.reservationId = this.$route.params.reservation_id;
        this.amendmentId = this.$route.params.amendment_id;
        this.state = this.$route.query.state;
        this.mail = this.$route.query.mail;

        this.state = parseInt(this.state);

        if (this.state === NaN) {
          this.$router.push({ path: "/404" });
        }
      } else {
        this.$router.push({ path: "/404" });
      }
    },
    handleError(error) {
      this.action.processing = false;
      this.action.succeed = false;

      if (error.response) {
        if (error.response.data.errors) {
          if (Array.isArray(error.response.data.errors)) {
            this.action.message = error.response.data.errors[0];
          } else {
            for (var prop in error.response.data.errors) {
              if (!error.response.data.errors.hasOwnProperty(prop)) {
                continue;
              }
              this.action.message = error.response.data.errors[prop][0];
              break;
            }
          }
        } else {
          this.action.message = `Request failed with status code ${error.response.status}`;
        }
      } else if (error.request) {
        this.action.message = `Something wrong with request messages.`;
      } else {
        this.action.message = `Something went wrong, please try again later.`;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reservation/amend/Confirmation.vue